import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { FC, ReactNode } from "react";
import TextField from "shared/components/Form/TextField";
import { InputHookResult } from "shared/hooks/useInputState";
import { COLOR_BLACK, COLOR_ERROR, COLOR_GREY_12 } from "shared/theme/colors";
import {
  StyledBox,
  StyledButtonsPopup,
  StyledModal,
  StyledTitle,
  StyledCancelButton,
  StyledConfirmButton,
} from "./styled";

type Props = {
  title: string;
  subtitle: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  descriptionInput?: InputHookResult;
  warningMessage?: ReactNode;
};

const ConfirmMaintenanceModal: FC<Props> = ({
  isOpen,
  onConfirm,
  onCancel,
  isLoading,
  title,
  subtitle,
  descriptionInput,
  warningMessage,
}) => {
  return (
    <StyledModal open={isOpen} onClose={onCancel}>
      <StyledBox>
        <Stack flexDirection="row">
          <Box />
          <StyledTitle variant="heading3" color={COLOR_BLACK}>
            {title}
          </StyledTitle>
        </Stack>
        <Box>
          <Typography color={COLOR_GREY_12}>{subtitle}</Typography>
        </Box>
        {warningMessage && warningMessage}
        <Box>
          <TextField
            id="brandMaintenanceModeDescription"
            label="Admin Notes (Optional)"
            fullWidth
            multiline
            minRows={6}
            placeholder="Enter notes"
            required
            value={descriptionInput?.input.value}
            onChange={descriptionInput?.input.onChange}
            labelColor={COLOR_BLACK}
          />
        </Box>
        <StyledButtonsPopup>
          <StyledConfirmButton
            title="Enable Maintenance Mode"
            onClick={onConfirm}
            size="small"
            loading={isLoading}
            buttonColor={COLOR_ERROR}
          />
          <StyledCancelButton
            title="Cancel"
            onClick={onCancel}
            size="small"
            variant="outlined"
          />
        </StyledButtonsPopup>
      </StyledBox>
    </StyledModal>
  );
};

export default ConfirmMaintenanceModal;
